import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker } from '@glu/datepicker-react';
import MobileGridContext from '../logic/MobileGridContext';
import * as actions from '../logic/actions';

const DateFilter = ({ column }) => {
  const gridContext = React.useContext(MobileGridContext);
  const { field, headerName } = column;
  const filterValues = gridContext?.unAppliedFilterState.filter(
    (filter) => filter.field === field
  );
  const filterFromDateValue = filterValues[0]?.filterData?.dateFrom
    ? moment(filterValues[0]?.filterData?.dateFrom)
    : undefined;
  const filterToDateValue = filterValues[0]?.filterData?.dateTo
    ? moment(filterValues[0]?.filterData?.dateTo)
    : undefined;
  const filterDateValue = [filterFromDateValue, filterToDateValue];
  return (
    <DatePicker
      onApply={(_, value) => {
        const dateFrom = value[0].format('YYYY-MM-DD');
        const dateTo = value[1].format('YYYY-MM-DD');
        actions.updateUnappliedFilters({
          gridContext,
          payload: {
            name: field,
            value: {
              field,
              nameDisplay: headerName,
              criteriaDisplay: `${dateFrom} to ${dateTo}`,
              id: `${field}-inRange-${dateFrom} to ${dateTo}`,
              filterData: {
                dateFrom,
                dateTo,
                format: 'YYYY-MM-DD',
                type: 'inRange',
                filterType: 'date',
                inRangeInclusive: 'true'
              }
            }
          }
        });
      }}
      name={`${field}-filter`}
      format="MM/DD/YYYY"
      value={filterDateValue}
      {...column?.filterOptions?.datePicker}
    />
  );
};

// {
//   field: "activated",
//   nameDisplay: "Activated",
//   criteriaDisplay: "2020-11-10 to 2020-11-30",
//   id: "activated-inRange-2020-11-10 to 2020-11-30",
//   filterData: {
//     dateFrom: "2020-11-10",
//     dateTo: "2020-11-30",
//     format: "YYYY-MM-DD",
//     type: "inRange",
//     filterType: "date",
//     inRangeInclusive: "true",
//   },
// },

// {
// 	"field": "approvalDate",
// 	"nameDisplay": "Approval Date",
// 	"criteriaDisplay": "2020-12-15 to 2020-12-28",
// 	"id": "approvalDate-inRange-2020-12-15 to 2020-12-28",
// 	"filterData": {
// 		"dateFrom": "2020-12-15",
// 		"dateTo": "2020-12-28",
// 		"format": "YYYY-MM-DD",
// 		"type": "inRange",
// 		"filterType": "date",
// 		"inRangeInclusive": "true"
// 	}
// }

DateFilter.propTypes = {
  column: PropTypes.shape({
    field: PropTypes.string,
    headerName: PropTypes.string,
    filterOptions: PropTypes.shape({
      datePicker: PropTypes.shape({})
    })
  }).isRequired
};

export default DateFilter;
